<template>
  <span
    class="tooltip"
    @mouseenter="togglePopIn()"
    @mouseleave="togglePopIn()"
  >
    <div v-if="isOpen">
      <p>Cette agence propose le retour dans une agence différente de celle de départ</p>
    </div>
    <svg>
      <use xlink:href="#icon-one-way-black"></use>
    </svg>
  </span>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    togglePopIn() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped lang="scss">

span.tooltip {
  position: absolute;
  right: 11px;
}

span div {
  @include shadow(inset 0 0 0 1px rgba(224, 224, 224, 1));
  //@include transform(translate(0%, -20px));

  background-color: white;
  bottom: 0;
  padding: 10px;
  position: relative;
  right: 0;
  width: 150px;
  z-index: 999;

  @include teq-breakpoint($medium) {
    //@include transform(translate(calc(100% - 100px), -20px));
  }

  p {
    @include font-size(10px);

    color: black;
    display: flex;
    flex: 1;
    margin: 0;
  }
}

svg {
  height: 15px;
  width: 15px;
}
</style>
